import { getModify } from 'services/api/user/modify';
import { setUserModify } from 'action-creators/user';
import { updateProfileUsernameSuccess } from 'containers/Profiles/actions';
import * as actionType from './actionTypes';

export const userModify = params => dispatch => {
  dispatch(actionType.userModifyBegin());
  return getModify(params)
    .then(payload => {
      if (payload.error) dispatch(actionType.userModifyError(payload));
      else {
        dispatch(updateProfileUsernameSuccess(params));
        dispatch(setUserModify(params));
        const  {lasttouch, ...otherData} = payload || {};
        dispatch(actionType.userModifySuccess(otherData));
      }
    })
    .catch(error => {
      dispatch(actionType.userModifyError(error));
    });
};
